import { EventEmitter } from '@angular/core';

export class EventEmiterService {
  dataStr = new EventEmitter<any>();
  showTemplate = new EventEmitter<boolean>();
  dataPadding = new EventEmitter<boolean>();

  setTitle(title: string) {
    this.dataStr.emit(title);
  }

  setPadding(set: boolean) {
    this.dataPadding.emit(set);
  }

  setTemplate(template: boolean) {
    this.showTemplate.emit(template);
  }
}
